import { IRegionSpecialPromo } from '../../types/specialPromos';

const defaultState: IRegionSpecialPromo[] = [];

export function specialPromosReducer(state: IRegionSpecialPromo[] = defaultState): IRegionSpecialPromo[] {
  return state;
}
